import {useFormik} from 'formik';
import * as Yup from 'yup';
import {CreateFundraiserDocumentDTO} from './model';
import {useCreateFundraiserDocument} from '../lib';
import {AxiosError} from 'axios';

type UseAddDocumentFormProps = {
  appealId: string;
  setOpen: (open: boolean) => void;
};

export const useAddDocumentForm = ({appealId, setOpen}: UseAddDocumentFormProps) => {
  const {createDocumentMutation} = useCreateFundraiserDocument();

  const onSubmit = async (values: CreateFundraiserDocumentDTO) => {
    try {
      await createDocumentMutation.mutateAsync({appealId, dto: values});
      setOpen(false);
    } catch (error: any) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      uploadId: '',
      title: '',
      fileExtension: 'pdf',
    },
    validationSchema: Yup.object({
      uploadId: Yup.string().required('Файл обязателен'),
      title: Yup.string()
        .max(256, 'Название не должно превышать 256 символов')
        .required('Название документа обязательно'),
      fileExtension: Yup.string().nullable(),
    }),
    onSubmit: onSubmit,
  });

  return {
    values: formik.values,
    errors: formik.errors,
    touched: formik.touched,
    handleChange: formik.handleChange,
    handleBlur: formik.handleBlur,
    setFieldValue: formik.setFieldValue,
    setFieldTouched: formik.setFieldTouched,
    resetForm: formik.resetForm,
    submitForm: formik.submitForm,
    isValid: formik.isValid,
    isLoading: createDocumentMutation.isPending,
    submitError: createDocumentMutation.error
      ? (createDocumentMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    validateForm: formik.validateForm,
  };
};
